import { useState } from 'react'
import { useAuthSession } from '../auth/AuthSessionContext'

export function PartnerInviteClaim({ token }: { token: string }) {
  const { session, claimPartnerInvite, signOut } = useAuthSession()
  const [busy, setBusy] = useState(false)
  const [message, setMessage] = useState('')

  async function accept() {
    setBusy(true)
    setMessage('')
    try {
      await claimPartnerInvite(token)
      setMessage('Your independent partner space is ready. Refreshing your protected role...')
      window.location.replace('/')
    } catch (error) {
      setMessage(String((error as { message?: unknown })?.message ?? '').includes('verified_email_required')
        ? 'Verify your email first, then return to this same invitation link and sign in.'
        : 'The invitation could not be accepted. It may have expired, changed, or belong to a different email address.')
    } finally { setBusy(false) }
  }

  return <main className="partner-entry-shell"><section className="partner-entry-card">
    <p className="eyebrow">Independent partner account</p>
    <h1>Choose before anything is shared.</h1>
    <p>You are signed in as <strong>{session?.email}</strong>. Accepting creates a private partner workspace; it does not grant the man access to what you write.</p>
    <div className="partner-boundary-note"><strong>Your boundaries</strong><p>Each sharing purpose is off until you turn it on. You can decline, unlink, export or delete later without explaining why.</p></div>
    {message && <p className="partner-message" role="status">{message}</p>}
    <div className="partner-entry-actions"><button type="button" disabled={busy} onClick={() => void accept()}>{busy ? 'Creating protected space...' : 'Accept and review consent'}</button><button type="button" className="secondary-action" onClick={() => void signOut()}>Not now · sign out</button></div>
  </section></main>
}
